import { Grid, Skeleton, Stack } from "@mui/material";
import BroadCastStatusReport from "./BroadcastStatusReport";
import BroadcastReactionReport from "./BroadcastReactionReport";
import BroadcastNumReactionReport from "./BroadcastNumReactionReport";
import BroadcastFailStatusReport from "./BroadcastFailStatusReport";

export default function BroadCastingMedSectionSkeletonComponent() {
  return (
    <Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        gap="10px"
        alignItems="stretch"
        spacing={2}
        width="100%"
        // height="inherit"
        flexWrap="wrap"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <BroadCastStatusReport loading />
          </Grid>

          <Grid item xs={12} lg={6}>
            <BroadcastFailStatusReport loading />
          </Grid>

          <Grid item xs={12} lg={6}>
            <BroadcastReactionReport loading />
          </Grid>

          <Grid item xs={12} lg={6}>
            <BroadcastNumReactionReport loading />
          </Grid>
        </Grid>
      </Stack>

      <Stack
        mt="36px"
        gap="24px"
        direction="column"
        sx={{
          bgcolor: "white",
          borderRadius: "8px",
          py: "14px",
          px: "16px",
          borderColor: (theme) => theme.palette.others.borderColor,
          borderWidth: "1px",
          borderStyle: "solid",
          boxShadow: "none",
        }}
      >
        <Stack
          direction="column"
          justifyContent="space-between"
          alignItems="space-between"
          gap="10px"
          flexWrap="wrap"
        >
          <Stack
            direction="row"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Skeleton variant="rectangular" width="100px" height="30px" />
            <Skeleton variant="rectangular" width="100px" height="30px" />
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Skeleton variant="rectangular" width="100px" height="30px" />
            <Skeleton variant="rectangular" width="100px" height="30px" />
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Skeleton variant="rectangular" width="100px" height="30px" />
            <Skeleton variant="rectangular" width="100px" height="30px" />
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: "#ECEFF1",
              borderBottomStyle: "solid",
            }}
          >
            <Skeleton variant="rectangular" width="100px" height="30px" />
            <Skeleton variant="rectangular" width="100px" height="30px" />
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: (thm) => thm.palette.gray[200],
              borderBottomStyle: "solid",
            }}
          >
            <Skeleton variant="rectangular" width="100px" height="30px" />
            <Skeleton variant="rectangular" width="100px" height="30px" />
          </Stack>

          <Stack
            direction="row"
            gap="6px"
            width="100%"
            justifyContent="space-between"
            sx={{
              borderBottomWidth: ".5px",
              borderBottomColor: (thm) => thm.palette.gray[200],
              borderBottomStyle: "solid",
            }}
          >
            <Skeleton variant="rectangular" width="100px" height="30px" />
            <Skeleton variant="rectangular" width="100px" height="30px" />
          </Stack>
          <Stack
            direction="row"
            justifyContent="end"
            alignItems="center"
            width="100%"
            mt="4px"
          >
            <Skeleton variant="rectangular" width="100%" height="10px" />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
